/* Xvantage theme.js — colour-mode toggle + mobile menu. No dependencies. */
(function () {
  var root = document.documentElement;

  /* ---- Appearance: light -> dark -> invert (default from theme settings; visitor choice remembered) ---- */
  var MODES = ['light', 'dark', 'invert'];
  var LABEL = { light: 'Light', dark: 'Dark', invert: 'Inverted colors' };
  function setTheme(next, persist) {
    if (MODES.indexOf(next) < 0) next = 'light';
    root.setAttribute('data-theme', next);
    if (persist) { try { localStorage.setItem('xv-theme', next); } catch (e) {} }
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', next === 'light' ? '#ffffff' : '#000000');
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-label', 'Appearance: ' + LABEL[next] + '. Click to change');
      b.setAttribute('title', 'Appearance: ' + LABEL[next]);
    });
  }
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var i = MODES.indexOf(root.getAttribute('data-theme'));
      setTheme(MODES[(i + 1) % MODES.length], true);
    });
  });
  setTheme(root.getAttribute('data-theme'), false);

  /* ---- Mobile menu ---- */
  var header = document.querySelector('[data-header]');
  var menuBtn = document.querySelector('[data-menu-toggle]');
  if (header && menuBtn) {
    menuBtn.addEventListener('click', function () {
      var open = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', open ? 'false' : 'true');
      menuBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.getAttribute('data-open') === 'true') {
        header.setAttribute('data-open', 'false');
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.focus();
      }
    });
  }
})();
